import { DatabaseFoodItem } from '../../../../interfaces/DatabaseFoodItem';
import { FoodListItem } from '../../../../interfaces/FoodListItem';
import { RecipeIngredientFormValue } from '../../interfaces/RecipeFormValues';
import {
  measurementToUnitMacros,
  pickMacros,
} from '../measurementToUnitMacros/measurementToUnitMacros';

/**
 * A search row of either source becomes a new ingredient. Its values are per 1 unit on both
 * endpoints. A row with a bean id goes to `network` by that id, an own food that came from
 * Nutritionix included - the backend resolves it from its cache.
 */
export const foodToIngredientFormValue = (
  food: FoodListItem | DatabaseFoodItem,
): RecipeIngredientFormValue => {
  const isNetwork = food.my_net_diary_bean_id != null;

  return {
    ingredientId: null,
    foodId: isNetwork ? food.my_net_diary_bean_id : food.id,
    name: food.name,
    amount: food.amount,
    amountUnit: food.amountUnit ?? '',
    isNetwork,
    my_net_diary_bean_id: food.my_net_diary_bean_id,
    perUnit: pickMacros(food),
    measurements: (food.measurements ?? []).map(measurementToUnitMacros),
  };
};
